"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessagePump = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SyncMessagePump = /*#__PURE__*/function () {
  function SyncMessagePump() {
    _classCallCheck(this, SyncMessagePump);
    this.channels = {};
  }
  _createClass(SyncMessagePump, [{
    key: "createChannel",
    value: function createChannel(name) {
      if (this.channels[name]) {
        return;
      }
      var channelObject = {
        callbacks: []
      };
      this.channels[name] = channelObject;
    }
  }, {
    key: "subscribe",
    value: function subscribe(channel, callback) {
      this.createChannel(channel);
      if (!this.channels[channel].callbacks.includes(callback)) {
        this.channels[channel].callbacks.push(callback);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(channel, callback) {
      this.createChannel(channel);
      if (this.channels[channel].callbacks.includes(callback)) {
        var index = this.channels[channel].callbacks.indexOf(callback);
        if (index !== -1) {
          this.channels[channel].callbacks.splice(index, 1);
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy(channel) {
      if (this.channels.hasOwnProperty(channel)) {
        delete this.channels[channel];
      }
    }
  }, {
    key: "publish",
    value: function publish(channel, value) {
      this.createChannel(channel);
      if (this.channels[channel].callbacks.length) {
        this.channels[channel].callbacks.map(function (callback) {
          if (value === undefined) {
            callback(channel);
          } else {
            callback(channel, value);
          }
          return null;
        });
      }
    }
  }]);
  return SyncMessagePump;
}();
var _default = exports.default = SyncMessagePump;
var MessagePump = exports.MessagePump = new SyncMessagePump();